import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const Wrapper = styled.div`
  .ag-table .ag-root {
    border-color: ${colors.grey3};
    font-family: Roboto;
  }

  .ag-table .ag-header-cell,
  .ag-table .ag-header-group-cell {
    padding: 0 16px;
  }

  .ag-table .ag-header-cell::after,
  .ag-table .ag-header-group-cell::after {
    display: none;
  }

  .ag-table .ag-cell {
    letter-spacing: 0.8px;
    padding: 10px 16px;
  }

  .ag-table .ag-row.ag-row-last {
    border-bottom: none;
  }

  .ag-header-row {
    border-bottom: 1px solid ${colors.grey3};
  }

  .compare-year-table {
    .ag-root,
    .ag-root-wrapper,
    .ag-side-bar,
    .ag-status-bar {
      border-width: 0px;
    }
    .ag-row.compare-year-table--row {
      border: 0px;
      border-bottom: 1px solid ${colors.grey3};
    }
    .ag-header {
      background-color: transparent;
      border: none;
    }
    .ag-header-cell-label {
      justify-content: flex-end;
    }
    .ag-header-cell-text {
      font-size: 11px;
      font-weight: normal;
      color: ${colors.grey5};
    }
    .compare-year-table--header-year {
      .ag-header-cell-label {
        justify-content: flex-end;
      }
    }
  }
`;
